import SettingsIcon from "~/assets/icons/SettingsIcon";
import { Callout, ProductFilterObject, ShopSettings, VariantEdgeMetafields } from "~/types";
import NoImage from '~/assets/no_image_big.jpg';
import LowPriceIcon from "~/assets/home-icons/just-in-section/LowPriceIcon";
import MiddlePriceIcon from "~/assets/home-icons/just-in-section/MiddlePriceIcon";
import MiddleToTopPriceIcon from "~/assets/home-icons/just-in-section/MiddleToTopPriceIcon";
import TopPriceIcon from "~/assets/home-icons/just-in-section/TopPriceIcon";
import { getCurrencyByFormatting } from "~/lib/utils";
import IndexCallouts from "./callouts/IndexCallouts.client";
import { activeAffirmApp, digitalagent, multiStore, productListCustomise, productStockLabel, bulletsPrductoList, availabilityOptionsOnCard, showPriceSaleWithDetailText, showTextNextToLowestPrice, askForPriceLabelText, wishlistButton, isBrochure, wishlistButtonInProductCard, productWithoutStockLabel, roundNumberProductList } from "../../../setup/settings/__product";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../setup/settings/__nonTransactional";
import AffirmPromotion from "./AffirmPromotion.client";
import NoImageMultiStore from '~/assets/missingImage.jpg';
import FabricType from "~/assets/icons/FabricType";
import LeatherType from "~/assets/icons/LeatherType";
import ProductPriceDetailWithText from "./detail/ProductPriceDetailWithText.client";
import { useEffect, useState } from "react";
import WishlistButton from "../wishlist/WishListButton.client";

export default function ProductCard({ product, shopSettings, currency }: { product: ProductFilterObject, shopSettings: ShopSettings, currency: string }) {

    const redPriceProduct = shopSettings != null && shopSettings.priceRed != null ? shopSettings.priceRed : false;
    const redPriceStock = shopSettings != null && shopSettings.priceRedStock != null ? shopSettings.priceRedStock : false;
    const hideProductRangeBreadcumb = shopSettings != null && shopSettings.hideProductRangeBreadcumb != null ? shopSettings.hideProductRangeBreadcumb : false;
    const hideBrandBreadcumb = shopSettings != null && shopSettings.hideBrandBreadcumb != null ? shopSettings.hideBrandBreadcumb : false;
    const bulletpoints = product.customfields != null ? product.customfields.bulletpoints : null;
    const [displayPriceText, setDisplayPriceText] = useState(false);



    const formatNumber = (num: number): string => {
        var price = Number.isInteger(num) ? num.toString() : num.toFixed(roundNumberProductList.rounding);
        return price;
    };

    const getPrice = (numeric = false): number | JSX.Element | undefined | string => {
        if (isNonTransactional && !showPriceshowPriceTransactional) return;
        if (product.customfields.callforprice == 'Yes') {
            const calloutDefinitions: Callout[] = shopSettings?.calloutDefinitions != null ? shopSettings?.calloutDefinitions : [];
            const callForPriceCallout = calloutDefinitions.find(
                element => element.callout === "callforprice"
            );
            if (numeric) return 0;

            else return (
                <p>{askForPriceLabelText.enabled
                    ? callForPriceCallout?.label ?? askForPriceLabelText.default
                    : 'Ask for price'}</p>
            )
        }
        else if (product.customfields.pricelevel != null && !digitalagent) {
            if (numeric) return 0;
            else return getIconPrice(product);
        }
        else if (product?.oldprice != null && !digitalagent) {
            if (numeric) return product?.fromPrice
            else return (
                <span className="nowPrice">
                    <p className={`nowPrice_Card ${redPriceProduct || product.instock == 'Yes' && redPriceStock ? "ProductList__price-red" : ""}`}>{getCurrencyByFormatting(currency)} {formatNumber(product?.fromPrice)} </p>
                    <p className="oldPrice_Card">{getCurrencyByFormatting(currency)} {formatNumber(product?.oldprice)} </p>
                </span>
            )
        }
        else if (product?.fromPrice == product?.toPrice) {
            if (numeric) return formatNumber(product?.fromPrice);
            else return (
                <p className={`${product.instock == 'Yes' && redPriceStock ? "ProductList__price-red" : ""}`}>{getCurrencyByFormatting(currency)} {formatNumber(product?.fromPrice)}</p>
            )
        }
        else {
            if (numeric) {
                return formatNumber(product?.toPrice);
            } else {
                return (
                    showTextNextToLowestPrice.enabled ? (
                        <p className={`${product.instock == 'Yes' && redPriceStock ? "ProductList__price-red" : ""}`}>
                            <span>{showTextNextToLowestPrice.text}</span> {getCurrencyByFormatting(currency)} {formatNumber(product?.fromPrice)}
                        </p>
                    ) : (
                        <p className={`${product.instock == 'Yes' && redPriceStock ? "ProductList__price-red" : ""}`}>
                            {getCurrencyByFormatting(currency)} {formatNumber(product?.fromPrice)}
                            <span> - {getCurrencyByFormatting(currency)} {formatNumber(product?.toPrice)}</span>
                        </p>
                    )
                );
            }
        }
    }

    const getIconPrice = (product: ProductFilterObject) => {
        if (product.customfields.pricelevel == "TopPrice") {
            return <TopPriceIcon />;
        }
        if (product.customfields.pricelevel == "MidToTopPrice") {
            return <MiddleToTopPriceIcon />
        }
        if (product.customfields.pricelevel == "MidPrice") {
            return <MiddlePriceIcon />
        }
        if (product.customfields.pricelevel == "LowPrice") {
            return <LowPriceIcon />
        }
    }

    useEffect(() => {
        if (showPriceSaleWithDetailText.enabled && product?.oldprice != null && !digitalagent) {
            setDisplayPriceText(true);
        } else {
            setDisplayPriceText(false);
        }
    }, [product, shopSettings, showPriceSaleWithDetailText, digitalagent]);

    return (
        <div className="ProductList__product-item">
            <div className="ProductList__product-container">
                <div className="ProductList__product-topSection">
                    <div className="ProductList__card-section-top">
                        <IndexCallouts product={product} settings={shopSettings}></IndexCallouts>
                    </div>
                    <div className="ProductList__product-image">
                        <img src={product.images[0] && product.images[0] != '' ? product.images[0].includes("shopify") ? `${product.images[0]}&height=250` : `${product.images[0]}` : (multiStore ? NoImageMultiStore : NoImage)} alt="" />
                    </div>
                </div>
                <div className={`ProductList__product-bottomSection ${isNonTransactional && !showPriceshowPriceTransactional ? "nonTransactional" : ""}`}>
                    <div className="ProductList__product-description">
                        <div className={`down-section-card`}>
                            {product.instock == 'Yes' &&
                                <p className="label-bottom grey-label stock-label callout-in-stock">{productStockLabel.title}</p>
                            }
                            {productWithoutStockLabel.enabled && product.instock == 'No' &&
                                <p className="label-bottom stock-label callout-without-stock">{productWithoutStockLabel.title}</p>
                            }
                        </div>
                        {product?.brand && !hideBrandBreadcumb &&
                            <div className="ProductList__product-brand">
                                <a href={`/collections/${product?.brand.handle}/products`}>› {product?.brand.title}</a>
                            </div>
                        }
                        {product?.product_range && !hideProductRangeBreadcumb &&
                            <div className="ProductList__product-range">
                                <a href={`/collections/${product?.product_range.handle}/products`}>› {product?.product_range.title}</a>
                            </div>
                        }
                        <div className="ProductList__product-title">
                            <p>{product?.title}</p>
                        </div>
                    </div>
                    {activeAffirmApp.show &&
                        <div className="ProductList__price-section">
                            <AffirmPromotion price={+(getPrice(true) ?? 0) * 100} />
                        </div>
                    }
                    {bulletsPrductoList.enabled &&
                        <>
                            <div className="activeBullet">
                                {bulletpoints != null &&
                                    <div className="ProductList__bulletpoints"
                                        dangerouslySetInnerHTML={{ __html: bulletpoints }}>
                                    </div>
                                }
                            </div>
                        </>
                    }
                    {(availabilityOptionsOnCard.typeOfMaterialEnabled || availabilityOptionsOnCard.optionsCarouselEnabled) && (
                        <div className="ProductList__available-options">
                            {availabilityOptionsOnCard.typeOfMaterialEnabled && (
                                <div className="material-options">
                                    {product.customfields.infabric === 'Yes' && <FabricType />}
                                    {product.customfields.inleather === 'Yes' && <LeatherType />}
                                    {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'No' && (
                                        <p>Available in Leather</p>
                                    )}
                                    {product.customfields.inleather === 'No' && product.customfields.infabric === 'Yes' && (
                                        <p>Available in Fabric</p>
                                    )}
                                    {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'Yes' && (
                                        <p>Available in Leather and Fabric</p>
                                    )}
                                </div>
                            )}
                            {availabilityOptionsOnCard.optionsCarouselEnabled && product.optionsPreviewImages && product.optionsPreviewImages.length > 0 && (
                                <div className="image-container">
                                    {product.optionsPreviewImages.map((image, index) => (
                                        <img className="ProductList__options-image" key={index} src={image} alt={`Option ${index + 1}`} />
                                    ))}
                                    <a href={`/products/${product.handle}`}>See more</a>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="ProductList__priceWithText">
                        {showPriceSaleWithDetailText.enabled && displayPriceText && (
                            <ProductPriceDetailWithText />
                        )}
                    </div>
                    <div className="ProductList__price-section">
                        <div className='ProductList__price'>
                            {getPrice()}
                        </div>
                        {wishlistButton.showInProductCard && (
                            <div className="card-wishlist-button" onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                            }}>
                                <WishlistButton handle={product.handle} />
                            </div>
                        )}
                        <div className="ProductList__customise" data-tooltip={`${productListCustomise.title}`}>
                            {product?.hasoptions == 'Yes' && <span><SettingsIcon /></span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}